import React from 'react';
import {spaceSizes} from './spaceSize';

export interface SpaceProps {
  h?: number | string;
  w?: number | string;
}

type SizeKey = keyof typeof spaceSizes;
type NumSuffix<K extends SizeKey> = K extends `s${infer N}` ? N : never;

type SpaceWithHelpers = React.FC<SpaceProps> & {
  [K in SizeKey as NumSuffix<K> extends '' ? never : `H${NumSuffix<K>}`]:
  React.FC<Omit<SpaceProps, 'H'>>;
} & {
  [K in SizeKey as NumSuffix<K> extends '' ? never : `W${NumSuffix<K>}`]:
  React.FC<Omit<SpaceProps, 'W'>>;
};

const BaseSpace: React.FC<SpaceProps> = ({h = 0, w = 0}) => (
  <div style={{height: h, width: w}}/>
);

const Space = BaseSpace as SpaceWithHelpers;

(Object.entries(spaceSizes) as [SizeKey, number | string][])
  .forEach(([key, val]) => {
    const match = key.match(/^s(\d+)$/);
    if (!match) return;
    const suffix = match[1];
    // @ts-ignore
    Space[`H${suffix}`] = props => <BaseSpace h={val} {...props} />;
    // @ts-ignore
    Space[`W${suffix}`] = props => <BaseSpace w={val} {...props} />;
  });

export {spaceSizes};
export default Space;